import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import {
    COOKIE_CONSENT_UPDATED_EVENT,
    readCookieConsent,
} from './utils/cookieConsent';
import { initAnalyticsIfAllowed } from './utils/analytics';
import { captureAttribution } from './utils/attribution';

let sentryInitialized = false;

function initSentryIfAllowed(consent) {
    if (sentryInitialized || !process.env.REACT_APP_SENTRY_DSN || !consent?.analytics) {
        return;
    }

    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0.1,
    });
    sentryInitialized = true;
}

if (typeof window !== 'undefined') {
    captureAttribution();
    const consent = readCookieConsent();
    initSentryIfAllowed(consent);
    initAnalyticsIfAllowed(consent);
    window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, (event) => {
        initSentryIfAllowed(event.detail);
        initAnalyticsIfAllowed(event.detail);
    });
}
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ApiProvider } from './contexts/ApiContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrowserRouter } from 'react-router-dom';
import { startRuDateFormatting } from './utils/ruDates';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider>
            <AuthProvider>
                <ApiProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ApiProvider>
            </AuthProvider>
        </ThemeProvider>
    </React.StrictMode>
);

startRuDateFormatting(document.body);
